.contentWithPaddingForFooter {
    padding-bottom: 150px;
}

.formFieldRow {
    display: flex;
    flex-direction: row;
    gap: 20px;
}

.formField {
    flex: 1;
}

/* Accordion styles */
.accordionHeaderContainer {
    display: flex;
    width: 100%;
    justify-content: space-between;
    margin: 20px 0px 0px 0px;
    padding: 5px 0px 5px 12px;
    border-radius: 9px;
    background-color: rgba(5, 60, 89, .06);
}

.accordionRightContent {
    display: flex;
    flex: 0 0 565px;
    margin: 0px 0px 0px 4px;
    align-items: center;
}

.accordionRow {
    display: flex;
    width: 100%;
    justify-content: space-between;
}

.control {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: center;
}

.question {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: center;
    padding: 6px 0px;
}

/* Checkbox alignment */
.accordionRightContent p {
    width: 105px;
    text-align: center;
}

.overflowMenuSpacer {
    width: 40px;
}

.checkboxSpacer {
    width: 525px;
}

.requiredOrUnacceptable {
    color: var(--hps-red);
}